export default __webpack_public_path__ + "static/media/Bandit's Gloves of the Covert Trail.f518961e.jpg";